module.exports = __webpack_public_path__ + "img/Danke_tyresnparts_startseite.5305cee0.png";